var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.loading)?_c('div',{staticClass:"text-center"},[_c('coozzy-spinner')],1):(_vm.action === 'accept')?_c('div',[_vm._v(" "+_vm._s(_vm.$t('message.successMessages.eventAccepted'))+" ")]):_c('div',[_vm._v(" "+_vm._s(_vm.$t('message.successMessages.eventDeclined'))+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }